import Vue from 'vue'
import Store from './store'
import EventBus from './eventbus'
import { userLoggedIn } from './helpers'
import EventListener from './eventlistener'
import MarkerIcon from './components/MarkerIcon'
import MenuButton from './components/MenuButton'
import Bigsearch from './components/Bigsearch.vue'

if (document.querySelector('#VueHead')) {

  new Vue ({
    name: 'navigation',
    el: '#VueHead',
    delimiters: ['${', '}'],
    components: {
      MarkerIcon,
      MenuButton,
      Bigsearch,
    },

    data: {
      counterShown: true,
      loggedIn: false,
      wishlistBusy: false,
      mobileMenuOpen: false,
    },

    mounted: function () {
      EventListener.menuToggleListener(this.menuButtonClickHandler)
      this.boundUpdateCounter = this.doCounterUpdate.bind(this)
      this.wishlistListener()
    },

    computed: {
      counter() {
        return Store.wishlistTotal
      },

      searchShown() {
        return Store.searchShown
      },

      counterUpdated() {
        return this.counterShown && this.counter > 0
      },

      isMobile() {
        return Store.isMobile
      }
    },

    methods: {

      doCounterUpdate (event) {
        // prevent further clicks until yith done events trigger
        if (this.wishlistBusy) return false
        let changeBy = null
        // polyfill.io provides Element.prototype.closest for IE11
        if (event.target.closest('.add_to_wishlist')) {
          changeBy = 1
        } else if (event.target.closest('.remove')) {
          changeBy = -1
        }

        if (changeBy === null) return false
        this.wishlistBusy = true
        Store.updateCounter(changeBy)
        this.animateCounter()
      },

      wishlistListener() {
        if (userLoggedIn()) {
          this.loggedIn = true
          document.body.addEventListener('click', this.boundUpdateCounter)
          this.yithEventsListener()
        }
      },

      // listens for when Yith Wishlist Ajax is finished
      yithEventsListener() {
        if (typeof jQuery !== 'function') return false
        const body = jQuery(document.body)
        body.on('added_to_wishlist', () => this.wishlistBusy = false)
        body.on('removed_from_wishlist', () => this.wishlistBusy = false)
      },

      animateCounter() {
        // toggle to false for a whole tick
        // so DOM elements are removed and re-added
        // in order to restart its animation
        this.counterShown = false
        this.$nextTick(() => this.counterShown = true)
      },

      searchClicked() {
        EventBus.$emit('showSearch')
      },

      menuButtonClicked() {
        EventBus.$emit('toggleMenu')
      },

      menuButtonClickHandler() {
        this.mobileMenuOpen = !this.mobileMenuOpen
      },
    },
  })

}



// WEBPACK FOOTER //
// ./sportspower/assets/es6/navigation.js